<template>
  <div>
    <el-form :inline="true">
      <el-form-item>
        <el-input
                v-model="searchForm.version"
                placeholder="版本号"
                clearable
        >
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="getVersionPushList()">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="addVersionPush()">新增</el-button>
      </el-form-item>
    </el-form>

    <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            border
            stripe>
      <el-table-column
              prop="version"
              label="版本号"
              width="120">
      </el-table-column>
      <el-table-column
              prop="content"
              label="更新内容"
              width="600">
      </el-table-column>
      <el-table-column
              prop="createTime"
              width="200"
              label="创建时间"
      >
      </el-table-column>
      <el-table-column
              prop="icon"
              label="操作">

        <template slot-scope="scope">
          <el-button type="text" @click="editHandle(scope.row.id)">编辑</el-button>
          <el-divider direction="vertical"></el-divider>
          <template>
            <el-popconfirm title="您确定要进行删除操作吗？" @confirm="delHandle(scope.row.id)">
              <el-button type="text" slot="reference">删除</el-button>
            </el-popconfirm>
          </template>
          <el-divider direction="vertical"></el-divider>

          <template>
            <el-popconfirm title="您确定要进行此操作吗？" @confirm="sendHandle(scope.row.id)">
              <el-button type="text" slot="reference">推送</el-button>
            </el-popconfirm>
          </template>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            layout="total, sizes, prev, pager, next, jumper"
            :page-sizes="[10, 20, 50, 100]"
            :current-page="page.current"
            :page-size="page.size"
            :total="page.total">
    </el-pagination>

    <el-dialog
            :title="title"
            :visible.sync="dialogVisible"
            width="600px"
            :before-close="handleClose">
      <el-form :model="editForm" :rules="editFormRules" ref="editForm">
        <el-form-item label="版本号" prop="version" label-width="120px">
          <el-input v-model="editForm.version" style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="更新内容" prop="content" label-width="120px">
          <el-input type="textarea" :rows="5" maxlength="500" v-model="editForm.content" style="width: 400px" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm('editForm')">取 消</el-button>
        <el-button type="primary" @click="submitForm('editForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: "VersionPush",
    data() {
      return {
        title: '新增版本推送',
        searchForm: {},
        tableData: [],
        page: {
          total: 0,
          size: 10,
          current: 1,
        },
        dialogVisible: false,
        editForm: {},
        editFormRules: {
          version: [{required: true, message: '请输入版本号', trigger: 'blur'}],
          content: [{required: true, message: '请输入更新内容', trigger: 'blur'}]
        }
      }
    },
    created() {
      this.getVersionPushList(this.page)
    },
    methods: {
      addVersionPush() {
        this.dialogVisible = true
        this.title = '新增版本推送'
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.page.size = val
        this.getVersionPushList(this.page)
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.page.current = val
        this.getVersionPushList(this.page)
      },
      getVersionPushList(page) {
        this.$axios.post("/uxm/version-push/page", {
          version: this.searchForm.version,
          current: page == null ? this.page.current : page.current,
          size: page == null ? this.page.size : page.size,
        }).then(res => {
          this.tableData = res.data.data.records
          this.page.total = res.data.data.total
        })
      },
      handleClose() {
        this.resetForm('editForm')
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
        this.dialogVisible = false
        this.editForm = {}
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$axios.post('/uxm/version-push/' + (this.editForm.id ? 'edit' : 'add'), this.editForm)
              .then(res => {
                if(res.data.code === 200){
                  this.$message.success('操作成功！')
                  this.dialogVisible = false
                  this.getVersionPushList(this.page)
                }
                this.resetForm('editForm')
              })
          }
        })
      },
      editHandle(id) {
        this.dialogVisible = true
        this.title = '编辑版本信息'
        this.$axios.get('/uxm/version-push/info/' + id).then(res => {
          this.editForm = res.data.data
        })
      },
      delHandle(id) {
        this.$axios.post('/uxm/version-push/remove/' + id).then(res => {
          if(res.data.code === 200){
            this.$message.success('删除成功！')
            this.getVersionPushList(this.page)
          }
        })
      },
      sendHandle(id) {
        this.$axios.post('/uxm/version-push/push/' + id).then(res => {
          if(res.data.code === 200){
            this.$message.success('推送成功！')
            this.getVersionPushList(this.page)
          }
        })
      }
    }
  }
</script>

<style scoped>
  .el-pagination {
    float: right;
    margin-top: 22px;
  }
</style>
